import React, { useRef, useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import { Book } from "../../components/shared/book";
import { ASSETS_URL, store } from "../../components/Store";
import { useFavoritesManager } from "../../hooks/use-favorites-manager";
import _ from "lodash";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Mousewheel, Navigation, Pagination, A11y } from "swiper";

/**
 * Componente que retorna la fila con descripcion de libros
 * @property {string} text - texto descriptivo
 * @property {string} category - descrive la region de libros para accesibilidad
 * @property {object} txtsInterfaz - texto de interfaz
 * @property {array} books - arreglo de libros
 *  * @param {Object} props.navigationButtons - Referencias a los botones de navegación.
 * @returns {JSX.Element} DescriptiveRowBooks
 */
export const DescriptiveRowBooks = ({ text, txtsInterfaz,  books, navigationButtons }) => {
    const history = useHistory();
    const favoritesManager = useFavoritesManager();
    const favorites = favoritesManager?.favoriteBooks;
    const swiperRef = useRef(null);

    const globalState = useContext(store);
    const isAuthenticatedUser = globalState?.state?.sesionActiva === 'SI';

    const updateNavigation = (swiper) => {
        swiper.params.navigation.prevEl = navigationButtons?.prevButtonRef?.current
        swiper.params.navigation.nextEl = navigationButtons?.nextButtonRef?.current
        swiper.navigation.destroy()
        swiper.navigation.init()
        swiper.navigation.update()
    }

    const [isMobile, setIsMobile] = useState(window.innerWidth < 768 ? true : false);

    useEffect(() => {
        const setMobile = () => {
            let validacion;
            if (window.innerWidth < 768) {
                validacion = true;
            } else {
                validacion = false;
            }
            setIsMobile(validacion)
        }
        setMobile();
        window.addEventListener('resize', setMobile)
        return () => {
            window.removeEventListener('resize', setMobile)
        }
    }, [])

    return (
        <>
            <div className="collection-swiper-books d-flex aling-items-center mt-2">
                <div className="w-100 d-flex">
                    <div className="d-none d-xl-block col-description px-0" style={{ height: 300 }}>
                        <p>{text}</p>
                    </div>
                    <div className="col-books px-0 pl-xl-3 pr-0 d-flex justify-content-between" role="region">
                        <Swiper
                            ref={swiperRef}
                            className="w-100 swiper-descriptive-row"
                            style={{ overflowX: 'hidden' }}
                            slidesPerGroup={2}
                            slidesPerView={2}
                            spaceBetween={0}
                            breakpoints={{
                                510: {
                                    slidesPerView: 3,
                                    slidesPerGroup: 3,
                                },
                                578: {
                                    slidesPerView: 4,
                                    slidesPerGroup: 4,
                                },
                                726: {
                                    slidesPerView: 5,
                                    slidesPerGroup: 5,
                                },
                                886: {
                                    slidesPerView: 6,
                                    slidesPerGroup: 6,
                                },
                                1100: {
                                    slidesPerView: 7,
                                    slidesPerGroup: 7,
                                },
                                1200: {
                                    slidesPerView: 5,
                                    slidesPerGroup: 5,
                                },
                                1300: {
                                    slidesPerView: 6,
                                    slidesPerGroup: 6,
                                },
                                1500: {
                                    slidesPerView: 7,
                                    slidesPerGroup: 7,
                                },
                                1700: {
                                    slidesPerView: 8,
                                    slidesPerGroup: 8,
                                },
                                1800: {
                                    slidesPerView: 8,
                                    slidesPerGroup: 8,
                                },
                                1900: {
                                    slidesPerView: 9,
                                    slidesPerGroup: 9,
                                },
                            }}
                            mousewheel={{
                                forceToAxis: true,
                            }}
                            navigation={{
                                nextEl: navigationButtons?.nextButtonRef?.current,
                                prevEl: navigationButtons?.prevButtonRef?.current,
                            }}
                            onSwiper={(swiper) => {
                                updateNavigation(swiper);
                            }}
                            pagination={{
                                clickable: isMobile ? true : false,
                                enabled: isMobile ? true : false,
                            }}
                            modules={[Autoplay, Navigation, Mousewheel, Pagination, A11y]}
                            autoplay={{
                                delay: 5000,
                                disableOnInteraction: false,
                            }}
                            a11y={{
                                containerMessage: text,
                                itemRoleDescriptionMessage: txtsInterfaz && txtsInterfaz.getText({ id: "descriptiveRow.itemRoleDescriptionMessage", defaultText: "agrupacion de libros" }),
                            }}
                            onSlideChange={(swiper) => {
                                const activeSlide = swiper.slides[swiper.activeIndex];
                                if (activeSlide) {
                                    activeSlide.focus();
                                }
                            }}
                        >
                            {books.map((book, i) => {
                                return (
                                    <SwiperSlide
                                        className="focusable-by-children-secondary d-flex justify-content-center"
                                        key={`banner${i}`}
                                    >
                                        <Book
                                            libro={{
                                                ...book,
                                                portada: `${ASSETS_URL}${book?.url}`,
                                                title: book?.nombreLibro
                                            }}
                                            alSeleccionar={() => history.push(book?.link)}
                                            ocultarOpciones={{
                                                checkbox: true,
                                                bookType: false,
                                                botonFavoritos: isAuthenticatedUser ? false : true
                                            }}
                                            alAgregarFav={(item) => favoritesManager.add({ bookId: item?.idLibro })}
                                            alRemoverFav={(item) => favoritesManager.remove({ bookId: item?.idLibro })}
                                            estadoInicial={{
                                                esFavorito: favorites.some(fav => fav?.idLibro === book?.idLibro),
                                            }}
                                        />
                                    </SwiperSlide>
                                );
                            })}
                        </Swiper>
                    </div>
                </div>
            </div>
        </>
    )
}
